export default __webpack_public_path__ + "static/media/Akash_Jadhav.2fe50db9.pdf";